import * as React from "react";
import { cn } from "@/lib/utils";

interface GradientTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "sovereign" | "royal" | "premium" | "energy" | "innovation" | "warmth" | "success";
  as?: "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "div";
}

export function GradientText({
  variant = "sovereign",
  as: Tag = "span",
  className,
  children,
  ...props
}: GradientTextProps) {
  const gradientClass = {
    sovereign: "text-gradient-sovereign",
    royal: "text-gradient-royal",
    premium: "text-gradient-premium",
    energy: "text-gradient-energy",
    innovation: "text-gradient-innovation",
    warmth: "text-gradient-warmth",
    success: "text-gradient-success",
  }[variant];

  return (
    <Tag className={cn(gradientClass, className)} {...props}>
      {children}
    </Tag>
  );
}
